/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeData.defs'
export { main as default } from './removeData.defs'
